module.exports = __webpack_public_path__ + "static/media/1.d9e8ac97.jpg";